import type { FC } from "react";

import { getStoreFilterCategoryIcon } from "@locators/components/shared/utils/getStoreFiltersIcons";
import { getProductDisplay } from "@locators/components/shared/utils/shopProductTypes";
import type { ProductAttribute } from "@locators/components/StoreLocator";

import { SelectionTileItem } from "@jti/core-components";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import styles from "../StoreDetailsProductsByBrand.module.scss";

type HeaderItemProps = {
  item: ProductAttribute;
  iconContainerClassName?: string;
  groupName: string;
};

export const HeaderItem: FC<HeaderItemProps> = ({
  item,
  groupName,
  iconContainerClassName = styles.storeDetailsProductsColor,
}) => {
  const { __ } = useTranslations();
  const display = getProductDisplay(item.key);

  if (!display) return null;

  return (
    <SelectionTileItem
      readOnly
      key={item.key}
      label={__(display.i18nKey)}
      value={item.key}
      name={groupName}
      icon={getStoreFilterCategoryIcon({
        categoryKey: "product_types",
        filterKey: item.key,
        filtersItemIconContainerClassName: iconContainerClassName,
      })}
    />
  );
};
